{
  "types": {
    "Instruction": [
      { "name": "salt", "type": "uint256" },
      { "name": "maxExecutions", "type": "uint256" },
      { "name": "action", "type": "address" },
      { "name": "refuelERC20", "type": "RefuelERC20" }
    ],
    "RefuelERC20": [
      { "name": "token", "type": "address" },
      { "name": "target", "type": "address" },
      { "name": "threshold", "type": "uint256" },
      { "name": "endBalance", "type": "uint256" },
      { "name": "fee", "type": "Fee" }
    ],
    "Fee": [
      { "name": "token", "type": "address" },
      { "name": "maxBaseFeePerGas", "type": "uint256" },
      { "name": "maxPriorityFeePerGas", "type": "uint256" },
      { "name": "executionFee", "type": "uint256" }
    ]
  }
}
